import superagentPromisePlugin from 'superagent-promise-plugin'
import http_request from './http_request'
import http_agent from './http_agent'
import config from 'config'

function _genericCatch() {
	return {
		error_code: -1,
		payload: {
			message: 'Something went wrong. Please try again later.',
		},
	}
}

function followOwner(ownerUID) {
	return http_agent.post(config.api + 'storefront/' + ownerUID + '/follow')
		.send()
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(response) {
			const payload = JSON.parse(response.text)
			return payload
		})
		.catch(err => _genericCatch(err))
}

function getStorefrontOwnerData() {
	return http_request.get(config.api + 'storefront/me')
		.send()
}

function searchStorefrontLessons(page, order_field, order_type, search, limit = '') {
	return http_request.get(config.api + 'storefront/search')
		.send(
			{
				page,
				order_field,
				order_type,
				search,
				limit,
			}
		)
}

//let lesson = '{"data":{"id":"107858","presentation_uid":"3a0c904566921a762dc0830e1dba4fcd-1","entityUID":"3a0c904566921a762dc0830e1dba4fcd-1","firstName":"ftest","lastName":"081","name":"ftest081 bundle 1-2","description":"ftest081 bundle 1-2","size":1,"size_decimals":0.5,"created":"1429122202","created_formatted":"Apr 15, 2015","modified":"1444417307","modified_formatted":"Oct 9, 2015","published":7,"longDescription":"","longDescriptionSubheading":"","thumb":"https://dev-or.s3.amazonaws.com/dev/Slide/6941/iconlist.jpg?AWSAccessKeyId=AKIAIUV7X3VY6K3QZNDA&Expires=2147483647&Signature=ejLEYKxKAygBjAdORUpKHI%2BCQyI%3D&1373900724","imageUrl":"https://dev-or.s3.amazonaws.com/dev/Slide/6941/iconflash.jpg?AWSAccessKeyId=AKIAIUV7X3VY6K3QZNDA&Expires=2147483647&Signature=WjaJ%2FuF6SdxTTq3ykS9vtABm3ks%3D&1373900724","highlightImage":"","isStore":true,"hasRelatedAuthor":true,"inLibrary":false,"views":8,"isTutorial":false,"isFirstLesson":false,"price":"6.99","finalPrice":"0.00","productStoreId":"ftest081-bundle-1-2","free":false,"isAyce":true,"priceOriginal":"6.99","parentId":0,"totalSlides":"2","buyUrl":"https://app-dev.nearpod.us/ct/actions/presentation/buy.php?http_jwte=iuku3QNFVCHc2vTazCMcxQ2c5Tr009kl2nbfajxEQT2FQcdBj9IvXUBq4TcjxynbmyXmiyMkavs-VxnPOYH-4KyJmzcXPtHZBm368MZNX9GvjvBq8iRGMurIRioMGAITVsPd24Ii9ohzkZvkIkhslcC77DSILUbPs7Qal9B4_AyIsXDgCsMkPJvKaHMMwhQ8X-CbnzPe2Uo439BLJgHhl-LeoD-3jgC7N_O5zF5XeskD8ar6DaErU9XCCLeHO_2XYePgI-hQVpEPjg2xekZsPtMeuj80oZiOvsp-kZmYvR5N8t7Ml2DsX4IuXKM7Vle1iFThz3EXV6V_QqTj_yNRLrzWPbruOFKdkTi8kp7B5nk%3D&presentation_uid=3a0c904566921a762dc0830e1dba4fcd-1&appFrom=APP_HTML","used":"1","state":4,"orden":"1444417307","archived":"0","myLibraryEntityUID":"","publisher":"","pinCode":"","tags":[],"author":{"library_object_type":"4","data":{"entityUID":"15977","twitterUrl":"","name":"ftest 081","thumb":"https://app-dev.nearpod.us/ct/images/User/icondefault.jpg","location":"","bio":"","followers":5,"views":70,"grades":[{"name":"Kinder","selected":false},{"name":"Elementary","selected":false},{"name":"Middle","selected":false},{"name":"High","selected":false},{"name":"Higher Ed","selected":false},{"name":"Other","selected":false}],"subjects":[{"name":"Digital Citizenship","selected":false},{"name":"ELA","selected":false},{"name":"Health","selected":false},{"name":"Math","selected":false},{"name":"Science","selected":false},{"name":"Social Studies","selected":false},{"name":"Other","selected":false}],"coverUrl":"https://dev-or.s3.amazonaws.com/dev/StorefrontBackground/135198/iconweb_bg_list.jpg?AWSAccessKeyId=AKIAIUV7X3VY6K3QZNDA&Expires=2147483647&Signature=2yS191rzsZwsV70i2v9zFSfd4Ls%3D&1438795418","coverUrlWidget":"https://dev-or.s3.amazonaws.com/dev/StorefrontBackground/135198/iconweb_bg_widget.jpg?AWSAccessKeyId=AKIAIUV7X3VY6K3QZNDA&Expires=2147483647&Signature=JeCAQRcnG6WFUqmhS5xnxRdK4Vo%3D&1438795418","friendlyUrl":"https://www-dev.nearpod.us/s/ftest-081-A15977"}},"friendlyUrl":"https://www-dev.nearpod.us/s/social-studies/9th-grade/ftest081-bundle-12-L107858"},"library_object_type":"1"}'

function getStorefrontLessons(limit, page) {
	// return new Promise(function(resolve, reject) {
	// 	let entities = [], entity
	// 	for(let i = 0; i < 20; i += 1) {
	// 		entity = JSON.parse(lesson)
	// 		entity.data.entityUID = Math.round(Math.random()*100000000)
	// 		entity.data.name = entity.data.name + entity.data.entityUID
	// 		entities.push(entity)
	// 	}
	// 	setTimeout(function() {
	// 		resolve({error_code:0,payload:{
	// 			entities:entities,
	// 			more: page < 3
	// 		}})
	// 	},1000)

	// })
	// return http_agent.post(config.api + 'public-library/owner/lessons/get')
	// .send({
	// 	page
	// })

	return http_request.get(config.api + 'storefront/me/entities')
		.send({
			limit,
			page,
		})
}

function saveLessons(lessons) {
	return http_request.post(config.api + 'storefront/me/entities')
		.send({
			lesson_ids: lessons.join(','),
		})
}

function removeLesson(lesson_id) {
	return http_request.delete(config.api + 'storefront/me/entities?entityID=' + lesson_id)
		.send()
}

function getStorefrontVisitorData(ownerId) {
	return http_request.get(config.api + 'storefront/' + ownerId)
		.send()
}

function getStorefrontVisitorLessons(ownerId, limit, page) {
	return http_request.get(config.api + 'storefront/' + ownerId + '/entities')
		.send({
			limit,
			page,
		})
}

function sortLessons(lesson_ids) {
	return http_request.put(config.api + 'storefront/me/entities/sort')
		.send(
			{
				lesson_ids: lesson_ids.join(','),
			}
		)
}

function saveBio(bio) {
	return http_request.put(config.api + 'storefront/me')
		.send(
			{
				bio,
			}
		)
}

function unFollowOwner(ownerUID) {
	return http_request.delete(config.api + 'storefront/' + ownerUID + '/follow')
		.send()
}

export default {
	followOwner,
	getStorefrontOwnerData,
	searchStorefrontLessons,
	getStorefrontLessons,
	saveLessons,
	removeLesson,
	getStorefrontVisitorData,
	getStorefrontVisitorLessons,
	sortLessons,
	saveBio,
	unFollowOwner,
}
